import * as React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/fa'; // Import Persian locale
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';
import { Box, Paper, Typography } from '@mui/material';

// Add timezone plugin to dayjs
dayjs.extend(utc);
dayjs.extend(timezone);

const TimePicker = ({setTime}) => {
  // Set initial time to Iran's current time
  const [value, setValue] = React.useState(dayjs().tz('Asia/Tehran'));
  const [selectedTime, setSelectedTime] = React.useState(dayjs().tz('Asia/Tehran').format('HH:mm'));

  const handleTimeChange = (newValue) => {
    setValue(newValue);
    const formattedTime = newValue.format('HH:mm');
    setSelectedTime(formattedTime);
    setTime(formattedTime)
  };

  dayjs.locale('fa');

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fa">
      <Box
        dir="ltr"
        sx={{
          margin: 'auto',
          backgroundColor: 'transparent',
          textAlign: 'center',
          fontFamily: "Vazir",
          '& .MuiPickersLayout-root': {
            backgroundColor: 'transparent',
          }
        }}
      >
        <Paper 
          elevation={0} 
          sx={{ 
            padding: '0px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '& .MuiStaticTimePicker-root': {
              direction: 'ltr',
              '& .MuiClock-root': {
                width: '400px',
                height: '400px',
                backgroundColor: 'transparent',
                marginBottom: '0px',
                '& .MuiClockPointer-root': {
                  backgroundColor: '#6069E7',
                  '& .MuiClockPointer-thumb': {
                    backgroundColor: '#6069E7',
                    border: '2px solid #6069E7'
                  }
                },
                '& .MuiClock-pin': {
                  backgroundColor: '#6069E7'
                },
                '& .MuiClockNumber-root.Mui-selected': {
                  backgroundColor: '#6069E7'
                }
              }
            },
            '& .MuiClockNumber-root': {
              fontSize: '12px',
              fontWeight: 700,
              fontFamily: 'Vazir',
              color: '#1f2937'
            },
            '& .MuiPickersLayout-actionBar': {
              display: 'none'
            },
            '& .MuiTimeClock-root': {
              margin: '20px 0'
            },
            '& .MuiPickersArrowSwitcher-root': {
              position: 'relative',
              top: '0px',
              right:"-0px",
              justifyContent: 'center',
              width: '100%',
              '& .MuiIconButton-root': {
                padding: '12px',
                '& .MuiSvgIcon-root': {
                  fontSize: '3rem',
                  color: '#6069E7'
                }
              }
            },
            '& .MuiPickersCalendarHeader-root': {
              '& .MuiPickersArrowSwitcher-spacer': {
                width: '40px'
              }
            }
          }}
        >
          <StaticTimePicker
            displayStaticWrapperAs="mobile"
            value={value}
            onChange={handleTimeChange}
            hideTabs={true}
            sx={{
              '& .MuiPickersToolbar-root': {
                display: 'none'
              }
            }}
          />
          <Typography 
            sx={{ 
              fontSize: '2.5rem',
              fontWeight: 'bold',
              color: '#6069E7',
              marginTop: '-20px',
              fontFamily: 'Vazir',
            }}
          >
            {selectedTime}
          </Typography>
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default TimePicker;
